import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaEdit, FaFileDownload, FaUpload } from 'react-icons/fa';
import moment from 'moment';
import ErpTemplate from '../../components/ErpTemplate';
import UploadButton from '../../components/UploadButton';
import api from '../../services/api';
import '../../css/financeiro-parcela-pagar.css';

export default function EventoImportarOpcaoAereo({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem('empresa');
    const nomeEmpresa = localStorage.getItem('nomeEmpresa');
    const [arquivos, setArquivos] = useState([]);
    const [nomeEvento, setNomeEvento] = useState('');
    const token = localStorage.getItem('token');
    const { state } = useLocation();
    const history = useHistory();

    useEffect(() => {
        if (state?.nomeEvento) {
            setNomeEvento(state.nomeEvento);
        }
    }, [state]);

    const buscarArquivos = () => {
        api({
            method: 'get',
            action: '/eventoArquivo',
            token,
            params: {
                tipo: 'opcaoAereo',
                evento: id,
            },
        }).then((response) => {
            setArquivos(response.data.data);
        }).catch(() => {
            toast.error('Erro ao carregar arquivos importados');
        });
    };

    const buscarEvento = () => {
        if (!id || nomeEvento) {
            return;
        }

        api({
            method: 'get',
            action: '/evento/' + id,
            token,
        }).then((response) => {
            const evento = response.data.data;
            setNomeEvento(evento?.nomersvp ?? evento?.nome ?? '');
        }).catch(() => {
            // fallback silencioso
        });
    };

    useEffect(() => {
        buscarArquivos();
        // eslint-disable-next-line
    }, [id]);

    useEffect(() => {
        buscarEvento();
        // eslint-disable-next-line
    }, [id, nomeEvento]);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">{nomeEvento || 'Evento'}</h1>
                        <p className="fin-pp__subtitle">Opções de Aéreo</p>
                    </div>
                    <div className="fin-pp__actions">
                        <Link to={'/cadastroEventoRsvpOpcaoAereo/' + id} className="fin-pp__btn fin-pp__btn--pill">
                            <FaEdit size={14} /> Editar Opções Atuais
                        </Link>
                        <form method="get" target="_blank" action={(process.env.PUBLIC_URL ?? '') + '/modelo-opcoes-aereo.xlsx'} style={{ display: 'inline' }}>
                            <button type="submit" className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                                <FaFileDownload size={14} /> Baixar Modelo XLS
                            </button>
                        </form>
                    </div>
                </div>

                <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                    <p style={{ color: 'var(--fin-mt)', marginBottom: 12 }}>
                        Use o XLS quando quiser subir uma malha completa. Para correção pontual, prefira a edição manual e evite reimportações desnecessárias.
                    </p>
                    <UploadButton
                        icon={<FaUpload size={18} />}
                        color="primary"
                        acaoApi="eventoImportarOpcaoAereo"
                        title="Selecionar Arquivo"
                        beforeSend={() => {
                            toast.info('Aguarde, isso pode levar alguns minutos');
                        }}
                        callBack={(data) => {
                            if (data.result === 'sucesso') {
                                toast.success('Importação finalizada');
                                history.push('/cadastroEventoRsvpOpcaoAereo/' + id);
                                return;
                            }

                            toast.error(data.message || data.error || 'Erro desconhecido');
                        }}
                        dados={{
                            empresa,
                            evento: id,
                        }}
                    >
                        Selecionar Arquivo
                    </UploadButton>
                </div>

                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div className="fin-pp__cphead" style={{ padding: '12px 16px' }}>
                        <span className="fin-pp__cphead-title">Histórico de arquivos</span>
                        <span className="fin-pp__cphead-sub">Últimos arquivos vinculados a este evento.</span>
                    </div>
                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl" style={{ tableLayout: 'auto' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: 90 }}>Arquivo</th>
                                    <th style={{ width: 220 }}>Data</th>
                                    <th>Operador</th>
                                </tr>
                            </thead>
                            <tbody>
                                {arquivos.length === 0
                                    ? <tr><td colSpan={3} className="fin-pp__empty">Nenhum registro</td></tr>
                                    : arquivos.map((row, idx) => (
                                        <tr key={row.id || idx}>
                                            <td>
                                                {row.arquivo?.id ? (
                                                    <form method="get" action={process.env.REACT_APP_API_URL + '/eventoArquivo/' + row.id} target="_blank" style={{ display: 'inline' }}>
                                                        <input type="hidden" name="token" value={localStorage.getItem('token')} />
                                                        <button type="submit" className="fin-pp__btn fin-pp__btn--sm" title="Baixar arquivo">
                                                            <FaFileDownload size={16} />
                                                        </button>
                                                    </form>
                                                ) : null}
                                            </td>
                                            <td>{moment(row.created_at).format('DD/MM/YYYY HH:mm')}</td>
                                            <td>{row.operador?.nome ?? ''}</td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}
